import clsx from 'clsx';
import { Fragment } from 'react';

import MobileScores from '@/modules/players/v2/tabs/overview/TournamentResults/MobileScores';
import Scores from '@/modules/players/v2/tabs/overview/TournamentResults/Scores';
import { getTeams } from '@/modules/players/v2/tabs/overview/TournamentResults/utils';
import { PlayerLiveGameStatusData } from '@/types/players.types';

interface MatchScoresDetailsProps {
  match: PlayerLiveGameStatusData;
  userId: string;
}

const MatchScoresDetails = ({ match, userId }: MatchScoresDetailsProps) => {
  const { teamOne, teamTwo } = getTeams(match);

  const formatTeamDisplay = (team: string, isWinner: boolean) => {
    if (!team) return null;

    if (team === 'TBD') {
      return <span>{team}</span>;
    }

    const players = team.split(', ');
    return players.map((player, index) => (
      <Fragment key={`${player}-${index}`}>
        {index > 0 && index % 2 === 0 && <span>, </span>}
        <span className={isWinner ? 'text-green-600' : ''}>
          {index % 2 === 0 ? (
            player
          ) : (
            <span className={isWinner ? 'text-green-600' : 'text-gray-900'}> {player}</span>
          )}
        </span>
      </Fragment>
    ));
  };

  const isTeamOneWinner = match.TeamID_Winner === match.TeamID_1;
  const isTeamTwoWinner = match.TeamID_Winner === match.TeamID_2;
  const medalWinnerRow =
    match.InBracketType === 'B' || match.InBracketType === 'GS' || match.InBracketType === 'GS2';

  return (
    <div
      className={clsx(
        'w-full sm:border-l',
        medalWinnerRow ? 'sm:border-white' : 'sm:border-gray-200'
      )}
    >
      <div className='flex items-center sm:h-full'>
        <div className='flex w-full flex-col'>
          <p
            className={clsx(
              'w-full border-b p-3 text-sm sm:text-base',
              medalWinnerRow ? 'border-white' : 'border-gray-200'
            )}
          >
            {formatTeamDisplay(teamOne, isTeamOneWinner)}
          </p>
          <MobileScores match={match} userId={userId} />
          <p
            className={clsx(
              'border-b p-3 text-sm sm:border-none sm:text-base',
              medalWinnerRow ? 'border-white' : 'border-gray-200'
            )}
          >
            {formatTeamDisplay(teamTwo, isTeamTwoWinner)}
          </p>
        </div>
        <Scores match={match} userId={userId} />
        <div
          className={clsx(
            'hidden w-[128px] border-b sm:block',
            medalWinnerRow ? 'border-white' : 'border-gray-200'
          )}
        />
      </div>
    </div>
  );
};

export default MatchScoresDetails;
